<template>
<f7-page class="success-view" :page-content="false">
  <div class="centered-container">
    <img src="@/assets/icons/order_success.png">
    <div class="t-1">Order placed Successfully</div>
    <f7-button fill round @click="exit">Back to home page</f7-button>
  </div>
</f7-page>
</template>

<script>
import { exitApp } from '@/lib/helper'

export default {
  methods: {
    exit () {
      exitApp()
    }
  }
}
</script>

<style lang="scss" scoped>
.success-view {
  .centered-container {
    position: absolute; left: 50%; top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    > img {
      display: block;
      width: 50px;
      margin: 0 auto;
    }
    .t-1 {
      font-size: 24px; font-weight: bold;
      margin: 30px 0 50px;
    }
  }
}
</style>
